export interface LayoutState {
  selectedSidebarItemName: string;
}

export const initialLayoutState: LayoutState = {
  selectedSidebarItemName: "Employees Contracts",
};
